var map = {
	"./Icon1.svg": 64710,
	"./Icon2.svg": 63845,
	"./Icon3.svg": 9124,
	"./Icon4.svg": 71275,
	"./Icon5.svg": 52218,
	"./Icon6.svg": 67305,
	"./IconHand.svg": 30866,
	"./JP1.svg": 3225,
	"./JP2.svg": 60874,
	"./JP3.svg": 2843,
	"./JP4.svg": 87572,
	"./JP5.svg": 32501,
	"./JP6.svg": 19542,
	"./JP7.svg": 59079,
	"./JP8.svg": 78512,
	"./JP9.svg": 76961,
	"./Learninghub-banner-mobile.svg": 1107,
	"./Line-blue.svg": 99281,
	"./Line-orange.svg": 50775,
	"./SmartWorks_PrimaryLogo_L001_SeabreezeBlue.svg": 59394,
	"./SmartWorks_PrimaryLogo_L001_SmartWhite.svg": 51860,
	"./Wave-01.svg": 79095,
	"./Wave-02.svg": 35972,
	"./accelerate-time.svg": 88953,
	"./accountability.svg": 6355,
	"./actionable-strategies.svg": 82894,
	"./adaptation.svg": 92837,
	"./affordable-solutions.svg": 67015,
	"./anthropic-cover.svg": 40576,
	"./anthropic-logo.svg": 77302,
	"./augumentation-hero.svg": 92760,
	"./balance.svg": 65586,
	"./blognotfound.svg": 79531,
	"./brand-consistency.svg": 58286,
	"./businessGrowth.svg": 16165,
	"./calendar.svg": 81780,
	"./candidate.svg": 51457,
	"./cares_hero_bg.svg": 32367,
	"./carrier-opportunity.svg": 28030,
	"./cb.svg": 98097,
	"./certified-professionals.svg": 6786,
	"./competitive-pay.svg": 15518,
	"./compliance.svg": 38631,
	"./contact-hero-bg.svg": 85989,
	"./copy.svg": 22541,
	"./cost-effective.svg": 25825,
	"./curve-line-blue.svg": 69759,
	"./curve-line-orange.svg": 57489,
	"./customer-cover.svg": 66920,
	"./customer-divac.svg": 11136,
	"./customer-satisfaction.svg": 97487,
	"./deal.svg": 98816,
	"./deliver-result.svg": 81925,
	"./designApp-hero.svg": 39034,
	"./dev-service-wave.svg": 46349,
	"./developer-hiring-bg-1.svg": 27024,
	"./developer-hiring-bg-2.svg": 16419,
	"./developer-hiring-bg-3.svg": 13106,
	"./developer-hiring-bg-4.svg": 47037,
	"./developer-hiring-bg.svg": 74674,
	"./developers-vector.svg": 67301,
	"./digu-professionals.svg": 51148,
	"./digu-startups.svg": 56730,
	"./discord.svg": 82146,
	"./divac-logo.svg": 96629,
	"./divacs-cover.svg": 41568,
	"./driving.svg": 50171,
	"./educational-support.svg": 68077,
	"./efficient-planning.svg": 69351,
	"./endToend-support.svg": 6919,
	"./enhanced-engagement.svg": 92008,
	"./erp.svg": 43165,
	"./event-hero-background.svg": 49460,
	"./excellence.svg": 24056,
	"./execute-contracts.svg": 57373,
	"./experience-nepal-bg.svg": 67917,
	"./expert-developer.svg": 16195,
	"./facebook.svg": 51378,
	"./flexible-scalability.svg": 10093,
	"./focused-development.svg": 79397,
	"./for-hiring-companies-hero.svg": 67862,
	"./fwa.svg": 56304,
	"./get-a-tailored-solution.svg": 30501,
	"./global-innovators.svg": 26833,
	"./grow-your-carrier.svg": 32622,
	"./growth.svg": 96723,
	"./heart-hand.svg": 75324,
	"./help-vector.svg": 88309,
	"./hero-roadmap.svg": 79057,
	"./hero-section-bg.svg": 98532,
	"./hero-staff-augmentation.svg": 97516,
	"./hired.svg": 23516,
	"./hwb.svg": 74105,
	"./ict.svg": 7186,
	"./identity-management-hero.svg": 1669,
	"./identity-step1.svg": 18036,
	"./identity-step2.svg": 5895,
	"./identity-step3.svg": 18774,
	"./identity-step4.svg": 94009,
	"./immediate-integration.svg": 37724,
	"./indepth-analysis.svg": 70553,
	"./innovation.svg": 12723,
	"./instagram.svg": 86166,
	"./interview-pre-vetted-candidates.svg": 35511,
	"./interview-schedule.svg": 83435,
	"./interview.svg": 6083,
	"./job-creation.svg": 21515,
	"./job-promotion.svg": 57291,
	"./learninghub-banner-desktop.svg": 47047,
	"./line.svg": 98400,
	"./linkedin.svg": 43816,
	"./mailsubmit.svg": 14355,
	"./map.svg": 78908,
	"./market-ready-focus.svg": 27495,
	"./market-testing.svg": 55017,
	"./match-your-tech-stack.svg": 21099,
	"./meet-your-team-and-kickoff-your-project.svg": 68449,
	"./missionAndVision-mobile.svg": 83698,
	"./missionAndVision.svg": 80275,
	"./mvp-dev-service.svg": 67669,
	"./mvp-development-img1.svg": 70168,
	"./mvp-development-img2.svg": 9003,
	"./newsletterbackground.svg": 39575,
	"./onboard-candidates.svg": 95426,
	"./onboard-talents.svg": 55313,
	"./payroll-compliance.svg": 99771,
	"./pd.svg": 65794,
	"./peak-performance.svg": 56806,
	"./people-analyzing-stuff.svg": 75604,
	"./people-climbing-ladder.svg": 88146,
	"./performance-optimization.svg": 45750,
	"./person-jumping.svg": 69358,
	"./person-with-laptop.svg": 4687,
	"./pfl.svg": 78660,
	"./pr.svg": 47036,
	"./presentation.svg": 47026,
	"./project-manager.svg": 36539,
	"./pt.svg": 41650,
	"./public-service.svg": 27219,
	"./qa-engineer.svg": 71190,
	"./quotes.svg": 29941,
	"./rb.svg": 50306,
	"./reliability.svg": 38818,
	"./respect.svg": 13780,
	"./resume.svg": 92343,
	"./review-hero.svg": 6323,
	"./righ-arrow.svg": 13824,
	"./right-arrow.svg": 2916,
	"./risk-reduction.svg": 29839,
	"./round-the-clock.svg": 93885,
	"./scalability-icon.svg": 44423,
	"./scalability.svg": 61459,
	"./scalable-solution.svg": 99549,
	"./schedule-an-intro-call.svg": 11943,
	"./seamless-integration.svg": 26374,
	"./secure-solution.svg": 48583,
	"./security-enhancements.svg": 39328,
	"./service-frame-batch.svg": 39172,
	"./service-icon-clock.svg": 92978,
	"./service-img.svg": 8145,
	"./service-img2.svg": 29809,
	"./sharpscribe-logo.svg": 16720,
	"./sharpscribe.svg": 78136,
	"./skill-development.svg": 20441,
	"./sra.svg": 98482,
	"./step1.svg": 76529,
	"./step2.svg": 21986,
	"./step3.svg": 84627,
	"./story-card-bg.svg": 5868,
	"./story-card-corner.svg": 15726,
	"./story-card-hover-bg.svg": 81831,
	"./swtp-badges_Coder.svg": 19847,
	"./swtp-badges_Communicator.svg": 20389,
	"./swtp-badges_Interview.svg": 72361,
	"./teamwork.svg": 15034,
	"./technical.svg": 97759,
	"./tell-us-your-requirements.svg": 32113,
	"./thankyou-image.svg": 23203,
	"./tiktok.svg": 824,
	"./tranining-hero-background.svg": 80394,
	"./underline.svg": 4242,
	"./understanding.svg": 73012,
	"./unlimited.svg": 2603,
	"./user-center.svg": 49739,
	"./user-feedback.svg": 62557,
	"./verify.svg": 71401,
	"./vetted.svg": 72950,
	"./wave-bg-lighten.svg": 99541,
	"./wave-fur-animation.svg": 56408,
	"./wave-vector-light-blue.svg": 91225,
	"./wave-vector-purple.svg": 70866,
	"./wave-vector.svg": 59851,
	"./welt.svg": 50866,
	"./whymatter.svg": 70979,
	"./work-place-that-works.svg": 18406,
	"./x-twitter.svg": 13192,
	"./youtube.svg": 85797
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19832;